export default {"src":"/_next/static/media/icon-social-linkedin-white.c916ba21.svg","height":23,"width":23,"blurWidth":0,"blurHeight":0};